<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 max-w-2xl w-full">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-bold">Alert Settings</h2>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>
      
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Alert Threshold</label>
          <input type="number" v-model="settings.threshold" class="input w-full" />
        </div>
        
        <div>
          <label class="flex items-center">
            <input type="checkbox" v-model="settings.emailAlerts" class="mr-2" />
            <span>Enable Email Alerts</span>
          </label>
        </div>
        
        <div class="flex justify-end space-x-2">
          <button @click="$emit('close')" class="btn btn-secondary">Cancel</button>
          <button @click="save" class="btn btn-primary">Save Settings</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

const emit = defineEmits(['close', 'save'])

const settings = ref({
  threshold: 60,
  emailAlerts: true
})

function save() {
  emit('save', settings.value)
}
</script>